/**
 * راهنمای ابعاد تصویر هم‌سو با قالب فرانت (کتابخانه دوره‌ها، جزئیات دوره، نوار دسته).
 * متن‌ها کوتاه و قابل کپی در فرم ادمین.
 */

/** تصویر شاخص دوره — کارت شبکه (نوار عریض)، لیست (مربع)، هیروی جزئیات (نوار عریض) */
export const COURSE_THUMBNAIL_HINT_FA = [
  'هم‌سو با سایت: کاور با object-cover پر می‌شود؛ لبه‌ها در نسبت‌های دیگر ممکن است بریده شوند.',
  'کارت شبکه و لیست در /courses: کاور شاخص با نسبت ۱۶:۹ (عرض کارت یا ~۱۶۸ تا ۱۹۲ px در لیست، ارتفاع خودکار). صفحهٔ دوره: همان نسبت ۱۶:۹.',
  'پیشنهاد: نسبت ۱۶:۹ با حداقل عرض ۱۲۰۰ px (مثلاً ۱۲۰۰×۶۷۵ یا ۱۹۲۰×۱۰۸۰). سوژهٔ اصلی را نزدیک مرکز کادر بگذارید تا در برش مربع کمتر قطع شود.',
  'فرمت: JPG، PNG یا WebP.',
].join(' ');

/** تصویر شاخص دستهٔ دوره — بندانگشتی نوار عنوان کتابخانه مربع است */
export const CATEGORY_COVER_HINT_FA = [
  'در سایت، تصویر دستهٔ انتخاب‌شده کنار عنوان کتابخانه دوره‌ها به‌صورت مربع (~۵۶×۵۶ تا ~۶۸×۶۸ px) با object-cover دیده می‌شود.',
  'پیشنهاد: مربع ۱:۱ با حداقل ۵۱۲×۵۱۲ px (یا ۲۵۶×۲۵۶ برای حجم کمتر). لوگو یا نماد وسط‌چین از عکس افقی کشیده بهتر است.',
  'فرمت: JPG، PNG یا WebP.',
].join(' ');
